var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeatedSeats32 = function SvgHeatedSeats32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7C5.5 8.983 4 8.983 4 10.997 4 13.012 5.5 13 5.5 15c0 1.997-1.5 1.98-1.5 4m6.064-12c0 1.983-1.5 1.983-1.5 3.997 0 2.015 1.5 2.003 1.5 4.002 0 1.998-1.5 1.982-1.5 4.001m6.45-12c0 1.983-1.5 1.983-1.5 3.997 0 2.015 1.5 2.003 1.5 4.002 0 1.998-1.5 1.982-1.5 4.001M26.315 9c-1.7 0-2.3-1.084-2.315-2.168-.026-2.306 1.65-4.77 3.872-3.473 2.002 1.167.82 2.616.368 3.765C28.027 7.706 27.662 9 26.315 9Zm-3.477 14.002c-.49-.02-.975.105-1.396.36a2.58 2.58 0 0 0-.981 1.08c-.318.87-.57 1.764-.75 2.674-.253.954-.466 1.921-.711 2.884h4.689c.097 0 .315-1.034.357-1.166.125-.398.249-.82.389-1.225.462-1.464 1.185-3.27-.447-4.277a2.31 2.31 0 0 0-1.15-.33ZM6.001 26.3l.115 3.7h12.746L20 25.061l-11.473-1.05a2.38 2.38 0 0 0-.965.109c-.31.102-.594.267-.832.484-.24.216-.428.48-.553.773A2.17 2.17 0 0 0 6 26.3v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.277 22.463 2.336-11.459s.57-2.085-.455-2.085c-1.567 0-2.733 1.085-3.6 2.352a23.52 23.52 0 0 0-3.284 6.74c-.653 2.29-.764 4.79.23 6.993.107.32.246.626.412.915l.26-.996",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeatedSeats32;